import {NotFoundController} from './not_found.controller';

function notFound404 ($stateProvider) {

    $stateProvider
        .state('not_found_404', {
            url: '/404',
	        controller: 'NotFoundController as NotFound',
            templateUrl: 'states/not_found_404/not_found_404.html',
            parent: 'app-layout',
            params: {
                title: '404 Page Not Found'
            }
        })
}

export default angular.module('not_found_404', [])
    .config(notFound404)
    .controller('NotFoundController', NotFoundController)


// WEBPACK FOOTER //
// ./modules/xray/states/not_found_404/not_found_404.module.js